//Constant file for HomeComponents

//Constants for Card.jsx
export const INTRODUCTION = "Hi, my name is";
export const MY_NAME = "The Minh Luong";
export const ROLE = "Software Developer";

//Constant for About.jsx
export const ABOUT_TITLE = "About Me";
export const ABOUT_LOCATION = "Montreal, Canada";
export const ABOUT_P1 = "I graduated with a Bachelor's degree in Software Engineering from ÉTS. With a strong passion for coding and problem-solving, I have developed expertise in JavaScript/TypeScript, Angular, Java, and SQL, allowing me to work across front-end, back-end, and database development.";
export const ABOUT_P2 = "My goal is to grow into a senior developer role, where I can contribute my skills to building complex and impactful software solutions. During my internships, I worked as a Full Stack Developer, customizing websites and delivering tailored solutions for diverse clients. These experiences sharpened my ability to adapt quickly and solve unique challenges.";
export const ABOUT_P3 = "Resilience is one of the defining qualities I bring to my work—I approach obstacles with determination and creativity, always seeking innovative solutions. Beyond my professional journey, I enjoy expressing my creativity through drawing and photography.";
export const BUTTON = "Working experiences";

//Constants for CSProjects.jsx
export const CS_PROJECTS_TITLE = "Computer Science Projects";
export const CS_PROJECTS_SUBTITLE = "Hover over the images to see the project type";
export const ACADEMIC_PROJECTS = "Academic Projects";
export const PERSONAL_PROJECTS = "Personal Projects";

//Constants for FreetimeProjects.jsx
export const FREETIME_PROJECTS_TITLE = "Freetime Projects";
export const FREETIME_PROJECTS_SUBTITLE = "Hover over the images to see the project type";
export const ART_PROJECTS = "Art Projects";
export const PHOTO_PROJECTS = "Photography Projects";

//Constants for Education.jsx
export const EDUCATION_TITLE = "Education";
export const ETS = "ÉTS - Montreal, Canada";
export const ETS_DEGREE = "Bachelor of Engineering - BE, Software Engineering, ";
export const MAISONNEUVE = "Maisonneuve College - Montreal, Canada";
export const MAISONNEUVE_DEGREE = "Pure and applied sciences, ";
export const COURSES_TITLE = "Relevant courses";
export const SHOW_COURSES = "Show Courses";
export const HIDE_COURSES = "Hide Courses";
export const ETS_COURSES = [
    "Object Oriented Programming and Conception",
    "High Performance Databases",
    "Data Structures and Algorithms",
    "Software Analysis and Design",
    "Software Architecture",
    "Design and Evaluation of User Interfaces",
    "Web Development Technologies",
    "Introduction to DevOps approach",
    "Software Security",
];
